<template>
  <div class="browser_category">
    <div class="browser_box" v-for="(item,index) in browserList" :key="index" @click="changeBrowser(item)">
      <img class="browser_icon" :src="item.imgUrl" alt="">
      <div class="browser_name">{{ item.name }}</div>
      <div class="browser_status" v-if="item.isChecked"></div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import browser360 from '@/assets/browser/360.png'
// import browserUc from '@/assets/browser/uc.png'
import browser360jisu from '@/assets/browser/360_jisu.png'
import browserQq from '@/assets/browser/qq.png'
import browser2345 from '@/assets/browser/2345.png'
import browserSougou from '@/assets/browser/sougou.png'
import browserChrome from '@/assets/browser/chrome.png'
import browserEdge from '@/assets/browser/edge.png'

const emits = defineEmits(['changeBrowser'])

const browserList = ref([
  {
    name: '360浏览器',
    isChecked: true,
    imgUrl: browser360
  },
  // {
  //   name: 'UC浏览器',
  //   isChecked: false,
  //   imgUrl: browserUc
  // },
  {
    name: '360极速浏览器',
    isChecked: false,
    imgUrl: browser360jisu
  },
  {
    name: 'QQ浏览器',
    isChecked: false,
    imgUrl: browserQq
  },
  {
    name: '2345浏览器',
    isChecked: false,
    imgUrl: browser2345
  },
  {
    name: '搜狗浏览器',
    isChecked: false,
    imgUrl: browserSougou
  },
  {
    name: '谷歌浏览器',
    isChecked: false,
    imgUrl: browserChrome
  },
  {
    name: 'Edge',
    isChecked: false,
    imgUrl: browserEdge
  },
])

function changeBrowser(item) {
  browserList.value.forEach(browser => {
    browser.isChecked = false
  })
  item.isChecked = true
  emits('changeBrowser',item)
}
</script>

<style lang="less" scoped>
@import './index.less';
</style>